require('./mortgageRequestViewProcess.scss');

// @vendors
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const classnames = require('classnames');

// @helpers
const { formatText } = require('core/i18n').i18n;
const tinHelper = require('utilities/tinHelper');
const { browserIsIE11orBelow } = require('utilities/browserUtils');
const { mortgagesMonthlyFeeSubtitleText } = require('utilities/mortgageHelper');

// @components
const OKModal = require('components/commons/OKModal/OKModal');
const { OKButton } = require('components/commons/OKButton/OKButton');
const sectionDocumentsHolderInfo = require('./sectionDocumentsHolderInfo');
const sectionDocumentsLivingPlace = require('./sectionDocumentsLivingPlace');
const sectionRelatedProducts = require('./sectionRelatedProducts');
const sectionSignaturePreparation = require('./sectionSignaturePreparation');
const { MortgageRequestManagerInfo } = require('components/mortgageRequest/mortgageRequestPanel/mortgageRequestManagerInfo/mortgageRequestManagerInfo');
const mortgageInfo = require('./mortgageInfo');
const { text } = require('components/mortgageRequest/mortgageRequestPanel/mortgageRequestViewProcess/initialValues');

// @actions
const viewProcessActions = require('actions/mortgageRequest/mortgageRequestViewProcess');

// @ constants
const mortgageRequestType = require('constants/mortgageRequestType');
const { MORTGAGE_TYPE } = require('constants/mortgageRequestType')

class MortgageRequestViewProcess extends React.Component {
    constructor(props) {
        super(props);

        this.handleDownloadDocument = this.handleDownloadDocument.bind(this);
        this.handlePrintDocument = this.handlePrintDocument.bind(this);
    }

    componentWillMount() {
        this.props.getData();
    }

    buildButtons() {
        const { mortgageRequestViewProcess } = this.props;

        return (
            <div className="row">
                <div className="col-xs-1">
                    <OKButton
                        size="small"
                        modifier="task"
                        loaderColor="dark"
                        loaderSize="small"
                        onClick={this.handleDownloadDocument}
                        loading={mortgageRequestViewProcess.get('isDownloading')}
                    >
                        <i className="icon-descargar" />
                    </OKButton>
                </div>
                <div className="col-xs-1">
                    <OKButton
                        size="small"
                        modifier="task"
                        loaderColor="dark"
                        loaderSize="small"
                        onClick={this.handlePrintDocument}
                        loading={mortgageRequestViewProcess.get('isPrinting')}
                    >
                        <i className="icon-imprimir" />
                    </OKButton>
                </div>
            </div>
        );
    }

    buildLeftPanel() {
        const {
            mortgageState,
            dataProprietor,
            summaryDocumentationState,
            estatesState,
            inmueblesState,
            mortgageRequestViewProcess,
            flagBasedFeatures
        } = this.props;

        const holderInfoData = {
            mortgageState,
            dataProprietor,
            summaryDocumentationState
        };

        const livingPlaceData = {
            mortgageState,
            estatesState,
            summaryDocumentationState,
            inmueblesState
        };

        const relatedProducts = mortgageRequestViewProcess.get('relatedProducts');
        const homeInsuranceEnabled = flagBasedFeatures.get('mortgage-home-insurance-enabled');

        const relatedProductsData = {
            relatedProducts,
            homeInsuranceEnabled
        }

        return (
            <div className="col-xs-6 mortgage-request-view-process__panel-left">
                {sectionDocumentsHolderInfo(holderInfoData)}
                {sectionDocumentsLivingPlace(livingPlaceData)}
                {sectionRelatedProducts(relatedProductsData)}
                {sectionSignaturePreparation(mortgageState)}
            </div>
        )
    }

    buildRightPanel() {
        const { mortgageConditions, mortgageConditionsType } = this.props;

        const conditions = mortgageConditions.get('conditions');
        const managerTitle = formatText('mortgageRequestManagerInfo-yourManagerWithYou');

        const processViewValues = {
            type: mortgageRequestType.getMortgageTypeText(mortgageConditionsType.get('tipoProducto')),
            amount: conditions.get('importeHipoteca'),
            term: conditions.get('plazo'),
            monthlyFee: mortgagesMonthlyFeeSubtitleText(conditions),
            tin: tinHelper.getTinText(conditions, true),
            tae: conditions.get('taeProd', 0),
            euribor: conditions.get('euriBorProd'),
            isFetching: conditions.get('isFetching') || mortgageConditionsType.get('isFetching')
        }

        return (
            <div className="col-xs-6 mortgage-request-view-process__panel-right">
                <div className="row mortgage-request-view-process__panel-right-mortgage-info-section">
                    <div className="col-xs-12">
                        {mortgageInfo(processViewValues)}
                    </div>
                </div>

                <div className="row mortgage-request-view-process__panel-right-manager-info-section">
                    <div className="col-xs-12">
                        <MortgageRequestManagerInfo managerTitle={managerTitle} />
                    </div>
                </div>
            </div>
        );
    }

    handleDownloadDocument(evt) {
        evt.preventDefault();
        this.props.downloadDocument('processViewReport');
    }

    handlePrintDocument(evt) {
        evt.preventDefault();
        this.props.printDocument();
    }

    render() {
        const { isOpen, onRequestClose,mortgageConditionsType } = this.props;
        const variableType =  mortgageConditionsType.get('tipoProducto');
        const leftPanel = this.buildLeftPanel();
        const rightPanel = this.buildRightPanel();
        const buttons = this.buildButtons();
        const textValue = text();
        const modalContentClasses = classnames('mortgage-request-view-process col-xs-12', {
            'mortgage-request-view-process--iexplorer': browserIsIE11orBelow()
        })
        const content = (
            <div className={modalContentClasses}>
                <div className="row mortgage-request-view-process__content">
                    {leftPanel}
                    {rightPanel}
                </div>
                {buttons}
               <p className='mortgage-request-view-process'>
                {variableType !== MORTGAGE_TYPE.FIJO && formatText('mortgageRequestMortgageEdit-mortgageModifyLegalText')}
                </p>
            </div>
        );

        return (
            <OKModal
                content={content}
                description={textValue.SUBTITLE}
                isOpen={isOpen}
                onCloseCallback={onRequestClose}
                size="large"
                title={textValue.TITLE}
            />
        );
    }
}

MortgageRequestViewProcess.propTypes = {
    isOpen: PropTypes.bool,
    onRequestClose: PropTypes.func,
    estatesState: PropTypes.object,
    summaryDocumentationState: PropTypes.object,
    dataProprietor: PropTypes.object,
    mortgageState: PropTypes.object,
    inmueblesState: PropTypes.object,
    mortgageConditionsType: PropTypes.object,
    mortgageConditions: PropTypes.object,
    getData: PropTypes.func,
    mortgageRequestViewProcess: PropTypes.object,
    flagBasedFeatures: PropTypes.object,
    downloadDocument: PropTypes.func,
    printDocument: PropTypes.func
};

module.exports.constructor = MortgageRequestViewProcess;

module.exports.MortgageRequestViewProcess = connect(state => ({
    estatesState: state.mortgageRequestEstates,
    summaryDocumentationState: state.mortgageRequestSummaryDocumentation,
    dataProprietor: state.mortgageRequestDataProprietor,
    mortgageState: state.mortgageRequestState,
    inmueblesState: state.mortgageRequestInmuebles,
    mortgageConditionsType: state.mortgageRequestConditionsType,
    mortgageConditions: state.mortgageRequestConditions,
    mortgageRequestViewProcess: state.mortgageRequestViewProcess,
    flagBasedFeatures: state.flagBasedFeatures
}), {
        getData: viewProcessActions.getData,
        downloadDocument: viewProcessActions.requestDownloadDocument,
        printDocument: viewProcessActions.requestPrintDocument
    })(MortgageRequestViewProcess);
